<!--
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
-->

<nav class="navbar bg-blue">
    <div class="navbar-container">
        <!-- Brand -->
        <div class="navbar-brand">
            <h2>ADC Portal</h2>
        </div>

        <!-- Mobile menu toggle -->
        <button class="mobile-menu-toggle" (click)="toggleMobileMenu()" [attr.aria-expanded]="isMobileMenuOpen" aria-label="Toggle mobile menu">
            <span class="hamburger-line" [class.active]="isMobileMenuOpen"></span>
            <span class="hamburger-line" [class.active]="isMobileMenuOpen"></span>
            <span class="hamburger-line" [class.active]="isMobileMenuOpen"></span>
        </button>

        <!-- Navigation menu (center) - desktop only -->
        <div class="navbar-content" [class.mobile-open]="isMobileMenuOpen">
            <ul class="navbar-nav">
                <li routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">
                    <a [routerLink]="['/']" (click)="closeMobileMenu()">Home</a>
                </li>
                <li [class.active]="isApisRouteActive()" *ngIf="isLoggedIn">
                    <a [routerLink]="['/apis']" (click)="closeMobileMenu()">API Catalog</a>
                </li>
                <!-- Desktop: Simple Athena link -->
                <li routerLinkActive="active" *ngIf="isLoggedIn" class="desktop-only">
                    <a [routerLink]="['/api-mesh']" (click)="closeMobileMenu()">Athena</a>
                </li>

                <!-- Mobile: Athena with submenu -->
                <li [class.active]="isApiMeshSubmenuActive()" *ngIf="isLoggedIn" class="api-mesh-parent mobile-only">
                    <div class="nav-item-header" (click)="toggleApiMeshExpanded()">
                        <span class="nav-text">Athena</span>
                        <span class="expand-icon" [class.expanded]="isApiMeshExpanded">▶</span>
                    </div>
                    <ul class="sub-nav" [class.visible]="isApiMeshExpanded">
                        <li class="sub-nav-item" [class.active]="isApiMeshOverviewActive()">
                            <a [routerLink]="['/api-mesh/overview']" (click)="closeMobileMenu()">Overview</a>
                        </li>
                        <li class="sub-nav-item" [class.active]="isApiMeshExplorerActive()">
                            <a [routerLink]="['/api-mesh/explorer']" (click)="closeMobileMenu()">API Explorer</a>
                        </li>
                        <li class="sub-nav-item" [class.active]="isApiMeshHaystackActive()">
                            <a [routerLink]="['/api-mesh/haystack']" (click)="closeMobileMenu()">GCP Product Data Points with Haystack Tags</a>
                        </li>
                    </ul>
                </li>
            </ul>
        </div>

        <!-- Auth section (responsive) -->
        <div class="navbar-auth" [class.mobile-open]="isMobileMenuOpen">
            <!-- Show user info and logout when authenticated -->
            <div class="navbar-user" *ngIf="isLoggedIn">
                <span class="user-name" *ngIf="userAccount">{{ getUserDisplayName() }}</span>
                <a href="javascript:void(0)" class="btn-logout" (click)="logout(); closeMobileMenu()">Logout</a>
            </div>

            <!-- Show sign in when not authenticated -->
            <div class="navbar-signin" *ngIf="!isLoggedIn">
                <a href="javascript:void(0)" class="btn-signin" (click)="login(); closeMobileMenu()">Login</a>
            </div>
        </div>
    </div>
</nav>

<main class="main-content">
    <router-outlet></router-outlet>
</main>
